import { useContext } from "react";
import cn from "classnames";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { selectPickedClient } from "@/shared/services/store/clientStore";
import { Action, Subject } from "@/shared/services/permissions/casl-ability.factory";
import { ClientAbilityContext } from "@/shared/contexts/ability.context";

import ErrorPage from "@/modules/main/ErrorPage/ErrorPage";
import { ICommonErrorPage } from "@/modules/main/Forbidden/Forbidden";

import buttonStyle from "@/ui-components/commonComponents/Button/style.module.css";
import { Loading } from "@/shared/components/Loading/Loading";

const buttonTitle: { default: string; notAuthorized: string } = {
  default: "open dashboard",
  notAuthorized: "log in",
};

export default function NotFound({ isSignedIn, isAdmin, isClient, isLoading = false }: ICommonErrorPage) {
  const clientId = useSelector(selectPickedClient);

  const clientAbility = useContext(ClientAbilityContext);
  const canViewAdminDashboard = clientAbility.can(Action.Manage, Subject.ALL);
  const canViewClientDashboard = clientAbility.can(Action.Read, Subject.CLIENT);
  const canViewAssessmentDashboard = clientAbility.can(Action.Read, Subject.ASSESSMENT);

  const route = isSignedIn
    ? canViewAdminDashboard
      ? "/admin"
      : canViewClientDashboard
      ? "/clients"
      : canViewAssessmentDashboard
      ? `/clients/${clientId}/assessments`
      : "/candidate/invites"
    : "/";

  if (isLoading) {
    return <Loading />;
  }

  return (
    <ErrorPage
      isSignedIn={isSignedIn}
      isAdmin={isAdmin}
      isClient={isClient}
      errorReason={"Sorry, the page you visited does not exist."}
    >
      <Link to={route} className={cn(buttonStyle.linkAsButton, buttonStyle.linkAsButtonPrimary)}>
        {!isSignedIn ? buttonTitle.notAuthorized : buttonTitle.default}
      </Link>
    </ErrorPage>
  );
}
